import api from 'core/api';

export const getUsers = () => api.get('/users/');

export const addUser = (user) => api.post('/users/', user);

export const editUser = (id, user) => api.put(`/users/${id}`, user);

export const removeUser = (id) => api.delete(`/users/${id}`);
